// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --seat-available: #155f82;
  /* --seat-booked: #fd7e14; */
  --seat-mybooked: #4752ba;
}

/* ============================= */
/* LEGEND                        */
/* ============================= */
.seat-legend {
  display: flex;
  gap: 16px;
  flex-wrap: nowrap;
  margin-bottom: 0;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 10px;
}

.legend-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  border: 2px solid;
  display: flex;
  align-items: center;
  justify-content: center;
}

.legend-icon.available {
  color: #155f82;
  border-color: #155f82;
  background-color: var(--seat-available);
}

.legend-icon.booked {
  color:var(--color-primary-orange);
  border-color: var(--color-primary-orange);
  background-color: var(--color-primary-orange);
}

.legend-icon.mybooked {
  color: var(--seat-mybooked);
  border-color: var(--seat-mybooked);
  background-color: var(--seat-mybooked);
}
.legend-icon.partiallybooked {
  background: linear-gradient(
    135deg,
    var(--color-primary-orange) 50%,
    var(--seat-mybooked) 50%
  );
  border-color: var(--color-primary-orange);
}


/* ============================= */
/* DATE HEADER                   */
/* ============================= */
.seat-date-header {
  font-size: 16px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 0;
}

.seat-date {
  color: #2c3e50;
}

/* ============================= */
/* ROOMS ROW                     */
/* ============================= */
.hall-wrapper {
  margin-top: 40px;
  overflow: visible !important;
}

.hall-center-boxes {
  display: flex;
  justify-content: center;
  gap: 40px;
  overflow: visible !important;
}

.hall-box {
  width: 220px;
  height: 350px;
  background: var(--color-white);
  border: 2px solid #cfd8dc;
  position: relative;
  padding-top: 36px;
  box-sizing: border-box;
  overflow: visible !important;
}

.hall-label {
  position: absolute;
  top: 0;
  right: 0;
  padding: 4px 10px;
  font-size: 11px;
  font-weight: 600;
  color: var(--color-white);
  background: #28a745;
  border-left: 1px solid #198754;
  border-bottom: 1px solid #198754;
}

/* ============================= */
/* SEATS (CUBICAL)               */
/* ============================= */
.room-seats {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 14px;
  padding: 16px;
  overflow: visible !important;
  /* justify-items: center; */
}

.seat-cube {
  width: 60px;
  height: 90px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  transition: all 0.25s ease;
  /* Default border and bg (for safety) */
  border: 2px solid var(--seat-available);
  background-color: var(--color-white);
  color: var(--seat-available);
  margin:0px;
  --tooltip-bg: #ffd9b7;
  --tooltip-text: #000;
  overflow: visible !important;
}

/* Seat states */
.seat-cube.available {
  border-color: var(--seat-available);
  background-color: #155f82;
  color: var(--color-white);
  --tooltip-bg: var(--seat-available);
  --tooltip-text: var(--color-white);
}

.seat-cube.booked {
  border-color: #7f4616;
  background-color: var(--color-primary-orange);
  color: var(--color-white);
  cursor: not-allowed;
  opacity: 0.9;
  --tooltip-bg: var(--color-primary-orange);
  --tooltip-text: var(--color-white);
}

.seat-cube.mybooked {
  border-color: #1e1f48;
  background-color: var(--seat-mybooked);
  color: var(--color-white);
  --tooltip-bg: var(--seat-mybooked);
  --tooltip-text: var(--color-white);
}

/* Hover effects */
.seat-cube.available:hover {
  /* transform: scale(1.12);
  box-shadow: 0 6px 14px rgba(25, 135, 84, 0.35); */
  background: #447f9b;
}

.seat-cube.mybooked:hover {
  /* transform: scale(1.12);
  box-shadow: 0 6px 14px rgba(102, 16, 242, 0.35); */
  background:  var(--seat-mybooked);
}

/* Seat status icon */
.seat-status-icon {
  position: absolute;
  top: 3px;
  right: 3px;
  font-size: 11px;
  line-height: 1;
}

.seat-cube.booked .seat-status-icon {
  color: var(--color-primary-orange);
}

.seat-cube.mybooked .seat-status-icon {
  color: var(--seat-mybooked);
}

/* ============================= */
/* ROOM LAYOUTS                  */
/* ============================= */

/* Room C → 2 columns, 3 rows */
.room-seats.room-c {
  display: grid;
  grid-template-columns: repeat(2, 60px);
  grid-template-rows: repeat(3, 80px);
  gap: 12px 2px;
  padding: 0;
  justify-content: center;
  align-content: center;
  
}
.room-seats.room-c .seat-cube {
  writing-mode: vertical-rl;
  text-orientation: mixed;
}
 
.room-seats.room-d,
.room-seats.room-e {
  display: grid;
  grid-template-columns: 1fr 60px 60px;
  grid-template-rows: 1fr 90px 90px;
  gap: 8px;
  height: 100%;
  padding: 8px;
}
/* RIGHT WALL (vertical stack) */
.room-d .seat-cube:nth-child(1),
.room-e .seat-cube:nth-child(1) {
  grid-column: 2;
  grid-row: 1;
  writing-mode: vertical-rl; 
  justify-self: end;
  transform: translateX(40px);
  z-index: 99;
}

.room-d .seat-cube:nth-child(2),
.room-e .seat-cube:nth-child(2) {
  grid-column: 2;
  grid-row: 2;
  writing-mode: vertical-rl; 
  justify-self: end;
  transform: translateX(40px);
  z-index: 99;
}

.seat-cube.flat {
  writing-mode: horizontal-tb;
  transform: none;
}

/* BOTTOM WALL (side by side) */
.room-d .seat-cube:nth-child(3),
.room-e .seat-cube:nth-child(3) {
  grid-column: 1;
  grid-row: 3;
  writing-mode: horizontal-tb;
  width: 90px;
  height: 60px;
  margin-top: 10px;
  justify-self: center;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
    z-index: 99;

}


.room-d .seat-cube:nth-child(4),
.room-e .seat-cube:nth-child(4) {
  grid-column: 2;
  grid-row: 3;
  writing-mode: horizontal-tb;
  transform: none;
  width: 90px;
  height: 60px;
  justify-self: end;
  transform: translateX(40px);
  margin-top: 10px;
    z-index: 99;

}
/* ============================= */
/* TOOLTIP                        */
/* ============================= */
.seat-tooltip {
  position: absolute;
  bottom: 120%;
  left: 0;
  transform: translateX(-50%);
  background-color: var(--tooltip-bg);
  color: var(--tooltip-text);
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 600;
  white-space: nowrap;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s ease;
  box-shadow: 0 2px 6px rgba(0,0,0,0.2);
  z-index: 9999;
  writing-mode: horizontal-tb !important; /* Force horizontal */
  text-orientation: mixed;
  text-align: left;
  writing-mode: horizontal-tb !important;
  transform: translateX(-50%) rotate(0deg) !important; 
  min-width: max-content;
}
.seat-tooltip .tooltip-row {
  display: flex;
  align-items: center;
  gap: 4px;
}

.seat-tooltip .tooltip-row:not(:last-child) {
  margin-bottom: 2px;
}
.seat-tooltip::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: var(--tooltip-bg) transparent transparent transparent;
}

.seat-cube:hover .seat-tooltip {
  opacity: 1;
}

/* ============================= */
/* THUMBNAIL                      */
/* ============================= */
.layout-thumbnail {
  position: absolute;
  bottom: 30px;
  right: 30px;
  width: 100px;
  cursor: pointer;
  border: 2px solid #ccc;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0 2px 6px rgba(0,0,0,0.2);
  z-index: 10;
}

.layout-thumbnail::before {
  content: '\\1F50D';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 32px;
  color: #fd7e14;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
  z-index: 1;
  pointer-events: none;
}

.layout-thumbnail img {
  width: 100%;
  display: block;
}
.seat-date-link {
  cursor: pointer;
  text-decoration: underline;
  font-weight: 600;
}

.seat-date-link:hover {
  opacity: 0.8;
}

.R-C {
  background-color:#F0F7F3 ;
  color:var(--color-primary-green) !important;
}

.R-D {
   background-color:#FFF7EF ;
   color:#B45F13 !important;
}

.R-E {
  background-color:#F1F6FA ;
  color:#1D4D78 !important;
}

.text-muted {
  font-weight: 700;
}
/* ============================= */
/* PARTIALLY BOOKED DIAGONALS     */
/* ============================= */
.seat-cube.partial {
  position: relative;
  color: var(--color-white);
  overflow: visible;

}

/* Morning booked / Evening free */
.seat-cube.partial.morning-booked {
  background: linear-gradient(135deg, var(--color-primary-orange) 50%, var(--seat-available) 50%);
}

/* Evening booked / Morning free */
.seat-cube.partial.evening-booked {
  background: linear-gradient(135deg, var(--seat-available) 50%, var(--color-primary-orange) 50%);
}

/* Morning by me / Evening free */
.seat-cube.partial.morning-mybooked {
  background: linear-gradient(135deg, var(--seat-mybooked) 50%, var(--seat-available) 50%);
}

/* Evening by me / Morning free */
.seat-cube.partial.evening-mybooked {
  background: linear-gradient(135deg, var(--seat-available) 50%, var(--seat-mybooked) 50%);
}


/* Both halves booked by different employees → diagonal split */
.seat-cube.partial.both-booked-morning-me {
  background: linear-gradient(135deg, var(--seat-mybooked) 50%, var(--color-primary-orange) 50%);
}

/* Both booked: Morning by someone else, Evening by ME */
.seat-cube.partial.both-booked-evening-me {
  background: linear-gradient(135deg, var(--color-primary-orange) 50%, var(--seat-mybooked) 50%);
}

/* Both booked by others (neither is me) */
.seat-cube.partial.both-booked-neither {
  background: linear-gradient(135deg, var(--color-primary-orange) 50%, var(--color-primary-orange) 50%);
}

/* AM/PM Labels */
.seat-cube.partial::before {
  content: "AM";
  position: absolute;
  top: 6px;
  left: 6px;
  font-size: 10px;
  font-weight: 700;
}

.seat-cube.partial::after {
  content: "PM";
  position: absolute;
  bottom: 6px;
  right: 6px;
  font-size: 10px;
  font-weight: 700;
}
/* ============================= */
/* REDUCE STAT TILES HEIGHT      */
/* ============================= */
.statCard {
  min-height: 100px !important;
  height: auto !important;
}

.statCard .card-body {
  padding: 10px 14px !important;
  min-height: auto !important;
}

.statCard .widgets-icons-2 {
  width: 60px !important;
  height: 60px !important;
  font-size: 28px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  flex-shrink: 0 !important;
}

.statCard p {
  font-size: 15px !important;
  margin-bottom: 2px !important;
  line-height: 1.2 !important;
}

.statCard h4 {
  font-size: 20px !important;
  margin: 2px 0 !important;
  line-height: 1.2 !important;
}

/* Make sure Card itself doesn't have excessive padding */
.statCard.card {
  margin-bottom: 0 !important;
}

/* ============================= */
/* DATE PICKER Z-INDEX FIX       */
/* ============================= */
.react-datepicker-popper {
  z-index: 10000 !important;
}

.react-datepicker {
  z-index: 10000 !important;
}

.react-datepicker-popper {
  z-index: 9999 !important;
}
@media (max-width: 768px) {
  .hall-wrapper {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .hall-center-boxes {
    justify-content: flex-start;
    padding: 0 12px;
  }

  .seat-legend {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    justify-content: flex-start;
    padding-bottom: 4px;
  }
}
@media (max-width: 768px) {
  .hall-wrapper {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .hall-center-boxes {
    flex-direction: column;   /* rooms stack one below another */
    align-items: center;
    gap: 20px;
    padding: 0 12px;
  }

  .seat-legend {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    justify-content: flex-start;
    padding-bottom: 4px;
  }

  /* Simplify Room D / Room E layout on mobile */
  .room-seats.room-d,
  .room-seats.room-e {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 10px;
    padding: 12px;
    height: auto;
  }

  .room-d .seat-cube,
  .room-e .seat-cube {
    grid-column: unset;
    grid-row: unset;
    writing-mode: horizontal-tb;
    justify-self: unset;
    transform: none;
    width: 70px;
    height: 70px;
    margin: 0;
  }

  .room-d .seat-cube:nth-child(1),
  .room-e .seat-cube:nth-child(1),
  .room-d .seat-cube:nth-child(2),
  .room-e .seat-cube:nth-child(2),
  .room-d .seat-cube:nth-child(4),
  .room-e .seat-cube:nth-child(4) {
    transform: none !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/containers/seat_booking/components/seatbooking.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA,kCAAkC;AAClC,kCAAkC;AAClC,kCAAkC;AAClC;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,uCAAuC;AACzC;;AAEA;EACE,iCAAiC;EACjC,yCAAyC;EACzC,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;EAClC,sCAAsC;AACxC;AACA;EACE;;;;GAIC;EACD,yCAAyC;AAC3C;;;AAGA,kCAAkC;AAClC,kCAAkC;AAClC,kCAAkC;AAClC;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,kCAAkC;AAClC,kCAAkC;AAClC,kCAAkC;AAClC;EACE,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA,kCAAkC;AAClC,kCAAkC;AAClC,kCAAkC;AAClC;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,aAAa;EACb,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,0BAA0B;EAC1B,uCAAuC;EACvC,uCAAuC;EACvC,oCAAoC;EACpC,4BAA4B;EAC5B,UAAU;EACV,qBAAqB;EACrB,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA,gBAAgB;AAChB;EACE,mCAAmC;EACnC,yBAAyB;EACzB,yBAAyB;EACzB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;EAC7C,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,yCAAyC;EACzC,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,sCAAsC;EACtC,yBAAyB;EACzB,kCAAkC;EAClC,kCAAkC;AACpC;;AAEA,kBAAkB;AAClB;EACE;mDACiD;EACjD,mBAAmB;AACrB;;AAEA;EACE;oDACkD;EAClD,iCAAiC;AACnC;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,kCAAkC;AAClC,kCAAkC;AAClC,kCAAkC;;AAElC,+BAA+B;AAC/B;EACE,aAAa;EACb,sCAAsC;EACtC,mCAAmC;EACnC,aAAa;EACb,UAAU;EACV,uBAAuB;EACvB,qBAAqB;;AAEvB;AACA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;;EAEE,aAAa;EACb,oCAAoC;EACpC,iCAAiC;EACjC,QAAQ;EACR,YAAY;EACZ,YAAY;AACd;AACA,gCAAgC;AAChC;;EAEE,cAAc;EACd,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,2BAA2B;EAC3B,WAAW;AACb;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,eAAe;AACjB;;AAEA,+BAA+B;AAC/B;;EAEE,cAAc;EACd,WAAW;EACX,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;IAChB,WAAW;;AAEf;;;AAGA;;EAEE,cAAc;EACd,WAAW;EACX,2BAA2B;EAC3B,eAAe;EACf,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,2BAA2B;EAC3B,gBAAgB;IACd,WAAW;;AAEf;AACA,kCAAkC;AAClC,mCAAmC;AACnC,kCAAkC;AAClC;EACE,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,2BAA2B;EAC3B,mCAAmC;EACnC,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,oBAAoB;EACpB,6BAA6B;EAC7B,qCAAqC;EACrC,aAAa;EACb,sCAAsC,EAAE,qBAAqB;EAC7D,uBAAuB;EACvB,gBAAgB;EAChB,sCAAsC;EACtC,mDAAmD;EACnD,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,mEAAmE;AACrE;;AAEA;EACE,UAAU;AACZ;;AAEA,kCAAkC;AAClC,mCAAmC;AACnC,kCAAkC;AAClC;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,cAAc;EACd,yCAAyC;EACzC,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;AACA;EACE,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;GACG,yBAAyB;GACzB,wBAAwB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;AACA,kCAAkC;AAClC,mCAAmC;AACnC,kCAAkC;AAClC;EACE,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;;AAEnB;;AAEA,kCAAkC;AAClC;EACE,+FAA+F;AACjG;;AAEA,kCAAkC;AAClC;EACE,+FAA+F;AACjG;;AAEA,iCAAiC;AACjC;EACE,wFAAwF;AAC1F;;AAEA,iCAAiC;AACjC;EACE,wFAAwF;AAC1F;;;AAGA,+DAA+D;AAC/D;EACE,8FAA8F;AAChG;;AAEA,wDAAwD;AACxD;EACE,8FAA8F;AAChG;;AAEA,0CAA0C;AAC1C;EACE,qGAAqG;AACvG;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,eAAe;EACf,gBAAgB;AAClB;AACA,kCAAkC;AAClC,kCAAkC;AAClC,kCAAkC;AAClC;EACE,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA,yDAAyD;AACzD;EACE,2BAA2B;AAC7B;;AAEA,kCAAkC;AAClC,kCAAkC;AAClC,kCAAkC;AAClC;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;AACA;EACE;IACE,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE,2BAA2B;IAC3B,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,iCAAiC;IACjC,2BAA2B;IAC3B,mBAAmB;EACrB;AACF;AACA;EACE;IACE,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE,sBAAsB,IAAI,kCAAkC;IAC5D,mBAAmB;IACnB,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,iCAAiC;IACjC,2BAA2B;IAC3B,mBAAmB;EACrB;;EAEA,8CAA8C;EAC9C;;IAEE,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,SAAS;IACT,aAAa;IACb,YAAY;EACd;;EAEA;;IAEE,kBAAkB;IAClB,eAAe;IACf,2BAA2B;IAC3B,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,YAAY;IACZ,SAAS;EACX;;EAEA;;;;;;IAME,0BAA0B;EAC5B;AACF","sourcesContent":[":root {\r\n  --seat-available: #155f82;\r\n  /* --seat-booked: #fd7e14; */\r\n  --seat-mybooked: #4752ba;\r\n}\r\n\r\n/* ============================= */\r\n/* LEGEND                        */\r\n/* ============================= */\r\n.seat-legend {\r\n  display: flex;\r\n  gap: 16px;\r\n  flex-wrap: nowrap;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.legend-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n.legend-icon {\r\n  width: 36px;\r\n  height: 36px;\r\n  border-radius: 8px;\r\n  border: 2px solid;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.legend-icon.available {\r\n  color: #155f82;\r\n  border-color: #155f82;\r\n  background-color: var(--seat-available);\r\n}\r\n\r\n.legend-icon.booked {\r\n  color:var(--color-primary-orange);\r\n  border-color: var(--color-primary-orange);\r\n  background-color: var(--color-primary-orange);\r\n}\r\n\r\n.legend-icon.mybooked {\r\n  color: var(--seat-mybooked);\r\n  border-color: var(--seat-mybooked);\r\n  background-color: var(--seat-mybooked);\r\n}\r\n.legend-icon.partiallybooked {\r\n  background: linear-gradient(\r\n    135deg,\r\n    var(--color-primary-orange) 50%,\r\n    var(--seat-mybooked) 50%\r\n  );\r\n  border-color: var(--color-primary-orange);\r\n}\r\n\r\n\r\n/* ============================= */\r\n/* DATE HEADER                   */\r\n/* ============================= */\r\n.seat-date-header {\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  color: #2c3e50;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.seat-date {\r\n  color: #2c3e50;\r\n}\r\n\r\n/* ============================= */\r\n/* ROOMS ROW                     */\r\n/* ============================= */\r\n.hall-wrapper {\r\n  margin-top: 40px;\r\n  overflow: visible !important;\r\n}\r\n\r\n.hall-center-boxes {\r\n  display: flex;\r\n  justify-content: center;\r\n  gap: 40px;\r\n  overflow: visible !important;\r\n}\r\n\r\n.hall-box {\r\n  width: 220px;\r\n  height: 350px;\r\n  background: var(--color-white);\r\n  border: 2px solid #cfd8dc;\r\n  position: relative;\r\n  padding-top: 36px;\r\n  box-sizing: border-box;\r\n  overflow: visible !important;\r\n}\r\n\r\n.hall-label {\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  padding: 4px 10px;\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  color: var(--color-white);\r\n  background: #28a745;\r\n  border-left: 1px solid #198754;\r\n  border-bottom: 1px solid #198754;\r\n}\r\n\r\n/* ============================= */\r\n/* SEATS (CUBICAL)               */\r\n/* ============================= */\r\n.room-seats {\r\n  display: grid;\r\n  grid-template-columns: repeat(3, 1fr);\r\n  gap: 14px;\r\n  padding: 16px;\r\n  overflow: visible !important;\r\n  /* justify-items: center; */\r\n}\r\n\r\n.seat-cube {\r\n  width: 60px;\r\n  height: 90px;\r\n  border-radius: 6px;\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  cursor: pointer;\r\n  position: relative;\r\n  transition: all 0.25s ease;\r\n  /* Default border and bg (for safety) */\r\n  border: 2px solid var(--seat-available);\r\n  background-color: var(--color-white);\r\n  color: var(--seat-available);\r\n  margin:0px;\r\n  --tooltip-bg: #ffd9b7;\r\n  --tooltip-text: #000;\r\n  overflow: visible !important;\r\n}\r\n\r\n/* Seat states */\r\n.seat-cube.available {\r\n  border-color: var(--seat-available);\r\n  background-color: #155f82;\r\n  color: var(--color-white);\r\n  --tooltip-bg: var(--seat-available);\r\n  --tooltip-text: var(--color-white);\r\n}\r\n\r\n.seat-cube.booked {\r\n  border-color: #7f4616;\r\n  background-color: var(--color-primary-orange);\r\n  color: var(--color-white);\r\n  cursor: not-allowed;\r\n  opacity: 0.9;\r\n  --tooltip-bg: var(--color-primary-orange);\r\n  --tooltip-text: var(--color-white);\r\n}\r\n\r\n.seat-cube.mybooked {\r\n  border-color: #1e1f48;\r\n  background-color: var(--seat-mybooked);\r\n  color: var(--color-white);\r\n  --tooltip-bg: var(--seat-mybooked);\r\n  --tooltip-text: var(--color-white);\r\n}\r\n\r\n/* Hover effects */\r\n.seat-cube.available:hover {\r\n  /* transform: scale(1.12);\r\n  box-shadow: 0 6px 14px rgba(25, 135, 84, 0.35); */\r\n  background: #447f9b;\r\n}\r\n\r\n.seat-cube.mybooked:hover {\r\n  /* transform: scale(1.12);\r\n  box-shadow: 0 6px 14px rgba(102, 16, 242, 0.35); */\r\n  background:  var(--seat-mybooked);\r\n}\r\n\r\n/* Seat status icon */\r\n.seat-status-icon {\r\n  position: absolute;\r\n  top: 3px;\r\n  right: 3px;\r\n  font-size: 11px;\r\n  line-height: 1;\r\n}\r\n\r\n.seat-cube.booked .seat-status-icon {\r\n  color: var(--color-primary-orange);\r\n}\r\n\r\n.seat-cube.mybooked .seat-status-icon {\r\n  color: var(--seat-mybooked);\r\n}\r\n\r\n/* ============================= */\r\n/* ROOM LAYOUTS                  */\r\n/* ============================= */\r\n\r\n/* Room C → 2 columns, 3 rows */\r\n.room-seats.room-c {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, 60px);\r\n  grid-template-rows: repeat(3, 80px);\r\n  gap: 12px 2px;\r\n  padding: 0;\r\n  justify-content: center;\r\n  align-content: center;\r\n  \r\n}\r\n.room-seats.room-c .seat-cube {\r\n  writing-mode: vertical-rl;\r\n  text-orientation: mixed;\r\n}\r\n \r\n.room-seats.room-d,\r\n.room-seats.room-e {\r\n  display: grid;\r\n  grid-template-columns: 1fr 60px 60px;\r\n  grid-template-rows: 1fr 90px 90px;\r\n  gap: 8px;\r\n  height: 100%;\r\n  padding: 8px;\r\n}\r\n/* RIGHT WALL (vertical stack) */\r\n.room-d .seat-cube:nth-child(1),\r\n.room-e .seat-cube:nth-child(1) {\r\n  grid-column: 2;\r\n  grid-row: 1;\r\n  writing-mode: vertical-rl; \r\n  justify-self: end;\r\n  transform: translateX(40px);\r\n  z-index: 99;\r\n}\r\n\r\n.room-d .seat-cube:nth-child(2),\r\n.room-e .seat-cube:nth-child(2) {\r\n  grid-column: 2;\r\n  grid-row: 2;\r\n  writing-mode: vertical-rl; \r\n  justify-self: end;\r\n  transform: translateX(40px);\r\n  z-index: 99;\r\n}\r\n\r\n.seat-cube.flat {\r\n  writing-mode: horizontal-tb;\r\n  transform: none;\r\n}\r\n\r\n/* BOTTOM WALL (side by side) */\r\n.room-d .seat-cube:nth-child(3),\r\n.room-e .seat-cube:nth-child(3) {\r\n  grid-column: 1;\r\n  grid-row: 3;\r\n  writing-mode: horizontal-tb;\r\n  width: 90px;\r\n  height: 60px;\r\n  margin-top: 10px;\r\n  justify-self: center;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  text-align: center;\r\n    z-index: 99;\r\n\r\n}\r\n\r\n\r\n.room-d .seat-cube:nth-child(4),\r\n.room-e .seat-cube:nth-child(4) {\r\n  grid-column: 2;\r\n  grid-row: 3;\r\n  writing-mode: horizontal-tb;\r\n  transform: none;\r\n  width: 90px;\r\n  height: 60px;\r\n  justify-self: end;\r\n  transform: translateX(40px);\r\n  margin-top: 10px;\r\n    z-index: 99;\r\n\r\n}\r\n/* ============================= */\r\n/* TOOLTIP                        */\r\n/* ============================= */\r\n.seat-tooltip {\r\n  position: absolute;\r\n  bottom: 120%;\r\n  left: 0;\r\n  transform: translateX(-50%);\r\n  background-color: var(--tooltip-bg);\r\n  color: var(--tooltip-text);\r\n  padding: 4px 8px;\r\n  border-radius: 6px;\r\n  font-size: 0.75rem;\r\n  font-weight: 600;\r\n  white-space: nowrap;\r\n  opacity: 0;\r\n  pointer-events: none;\r\n  transition: opacity 0.2s ease;\r\n  box-shadow: 0 2px 6px rgba(0,0,0,0.2);\r\n  z-index: 9999;\r\n  writing-mode: horizontal-tb !important; /* Force horizontal */\r\n  text-orientation: mixed;\r\n  text-align: left;\r\n  writing-mode: horizontal-tb !important;\r\n  transform: translateX(-50%) rotate(0deg) !important; \r\n  min-width: max-content;\r\n}\r\n.seat-tooltip .tooltip-row {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n}\r\n\r\n.seat-tooltip .tooltip-row:not(:last-child) {\r\n  margin-bottom: 2px;\r\n}\r\n.seat-tooltip::after {\r\n  content: '';\r\n  position: absolute;\r\n  top: 100%;\r\n  left: 50%;\r\n  margin-left: -5px;\r\n  border-width: 5px;\r\n  border-style: solid;\r\n  border-color: var(--tooltip-bg) transparent transparent transparent;\r\n}\r\n\r\n.seat-cube:hover .seat-tooltip {\r\n  opacity: 1;\r\n}\r\n\r\n/* ============================= */\r\n/* THUMBNAIL                      */\r\n/* ============================= */\r\n.layout-thumbnail {\r\n  position: absolute;\r\n  bottom: 30px;\r\n  right: 30px;\r\n  width: 100px;\r\n  cursor: pointer;\r\n  border: 2px solid #ccc;\r\n  border-radius: 6px;\r\n  overflow: hidden;\r\n  box-shadow: 0 2px 6px rgba(0,0,0,0.2);\r\n  z-index: 10;\r\n}\r\n\r\n.layout-thumbnail::before {\r\n  content: '\\1F50D';\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  font-size: 32px;\r\n  color: #fd7e14;\r\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);\r\n  z-index: 1;\r\n  pointer-events: none;\r\n}\r\n\r\n.layout-thumbnail img {\r\n  width: 100%;\r\n  display: block;\r\n}\r\n.seat-date-link {\r\n  cursor: pointer;\r\n  text-decoration: underline;\r\n  font-weight: 600;\r\n}\r\n\r\n.seat-date-link:hover {\r\n  opacity: 0.8;\r\n}\r\n\r\n.R-C {\r\n  background-color:#F0F7F3 ;\r\n  color:var(--color-primary-green) !important;\r\n}\r\n\r\n.R-D {\r\n   background-color:#FFF7EF ;\r\n   color:#B45F13 !important;\r\n}\r\n\r\n.R-E {\r\n  background-color:#F1F6FA ;\r\n  color:#1D4D78 !important;\r\n}\r\n\r\n.text-muted {\r\n  font-weight: 700;\r\n}\r\n/* ============================= */\r\n/* PARTIALLY BOOKED DIAGONALS     */\r\n/* ============================= */\r\n.seat-cube.partial {\r\n  position: relative;\r\n  color: var(--color-white);\r\n  overflow: visible;\r\n\r\n}\r\n\r\n/* Morning booked / Evening free */\r\n.seat-cube.partial.morning-booked {\r\n  background: linear-gradient(135deg, var(--color-primary-orange) 50%, var(--seat-available) 50%);\r\n}\r\n\r\n/* Evening booked / Morning free */\r\n.seat-cube.partial.evening-booked {\r\n  background: linear-gradient(135deg, var(--seat-available) 50%, var(--color-primary-orange) 50%);\r\n}\r\n\r\n/* Morning by me / Evening free */\r\n.seat-cube.partial.morning-mybooked {\r\n  background: linear-gradient(135deg, var(--seat-mybooked) 50%, var(--seat-available) 50%);\r\n}\r\n\r\n/* Evening by me / Morning free */\r\n.seat-cube.partial.evening-mybooked {\r\n  background: linear-gradient(135deg, var(--seat-available) 50%, var(--seat-mybooked) 50%);\r\n}\r\n\r\n\r\n/* Both halves booked by different employees → diagonal split */\r\n.seat-cube.partial.both-booked-morning-me {\r\n  background: linear-gradient(135deg, var(--seat-mybooked) 50%, var(--color-primary-orange) 50%);\r\n}\r\n\r\n/* Both booked: Morning by someone else, Evening by ME */\r\n.seat-cube.partial.both-booked-evening-me {\r\n  background: linear-gradient(135deg, var(--color-primary-orange) 50%, var(--seat-mybooked) 50%);\r\n}\r\n\r\n/* Both booked by others (neither is me) */\r\n.seat-cube.partial.both-booked-neither {\r\n  background: linear-gradient(135deg, var(--color-primary-orange) 50%, var(--color-primary-orange) 50%);\r\n}\r\n\r\n/* AM/PM Labels */\r\n.seat-cube.partial::before {\r\n  content: \"AM\";\r\n  position: absolute;\r\n  top: 6px;\r\n  left: 6px;\r\n  font-size: 10px;\r\n  font-weight: 700;\r\n}\r\n\r\n.seat-cube.partial::after {\r\n  content: \"PM\";\r\n  position: absolute;\r\n  bottom: 6px;\r\n  right: 6px;\r\n  font-size: 10px;\r\n  font-weight: 700;\r\n}\r\n/* ============================= */\r\n/* REDUCE STAT TILES HEIGHT      */\r\n/* ============================= */\r\n.statCard {\r\n  min-height: 100px !important;\r\n  height: auto !important;\r\n}\r\n\r\n.statCard .card-body {\r\n  padding: 10px 14px !important;\r\n  min-height: auto !important;\r\n}\r\n\r\n.statCard .widgets-icons-2 {\r\n  width: 60px !important;\r\n  height: 60px !important;\r\n  font-size: 28px !important;\r\n  display: flex !important;\r\n  align-items: center !important;\r\n  justify-content: center !important;\r\n  flex-shrink: 0 !important;\r\n}\r\n\r\n.statCard p {\r\n  font-size: 15px !important;\r\n  margin-bottom: 2px !important;\r\n  line-height: 1.2 !important;\r\n}\r\n\r\n.statCard h4 {\r\n  font-size: 20px !important;\r\n  margin: 2px 0 !important;\r\n  line-height: 1.2 !important;\r\n}\r\n\r\n/* Make sure Card itself doesn't have excessive padding */\r\n.statCard.card {\r\n  margin-bottom: 0 !important;\r\n}\r\n\r\n/* ============================= */\r\n/* DATE PICKER Z-INDEX FIX       */\r\n/* ============================= */\r\n.react-datepicker-popper {\r\n  z-index: 10000 !important;\r\n}\r\n\r\n.react-datepicker {\r\n  z-index: 10000 !important;\r\n}\r\n\r\n.react-datepicker-popper {\r\n  z-index: 9999 !important;\r\n}\r\n@media (max-width: 768px) {\r\n  .hall-wrapper {\r\n    overflow-x: auto;\r\n    -webkit-overflow-scrolling: touch;\r\n  }\r\n\r\n  .hall-center-boxes {\r\n    justify-content: flex-start;\r\n    padding: 0 12px;\r\n  }\r\n\r\n  .seat-legend {\r\n    overflow-x: auto;\r\n    -webkit-overflow-scrolling: touch;\r\n    justify-content: flex-start;\r\n    padding-bottom: 4px;\r\n  }\r\n}\r\n@media (max-width: 768px) {\r\n  .hall-wrapper {\r\n    overflow-x: auto;\r\n    -webkit-overflow-scrolling: touch;\r\n  }\r\n\r\n  .hall-center-boxes {\r\n    flex-direction: column;   /* rooms stack one below another */\r\n    align-items: center;\r\n    gap: 20px;\r\n    padding: 0 12px;\r\n  }\r\n\r\n  .seat-legend {\r\n    overflow-x: auto;\r\n    -webkit-overflow-scrolling: touch;\r\n    justify-content: flex-start;\r\n    padding-bottom: 4px;\r\n  }\r\n\r\n  /* Simplify Room D / Room E layout on mobile */\r\n  .room-seats.room-d,\r\n  .room-seats.room-e {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    justify-content: center;\r\n    gap: 10px;\r\n    padding: 12px;\r\n    height: auto;\r\n  }\r\n\r\n  .room-d .seat-cube,\r\n  .room-e .seat-cube {\r\n    grid-column: unset;\r\n    grid-row: unset;\r\n    writing-mode: horizontal-tb;\r\n    justify-self: unset;\r\n    transform: none;\r\n    width: 70px;\r\n    height: 70px;\r\n    margin: 0;\r\n  }\r\n\r\n  .room-d .seat-cube:nth-child(1),\r\n  .room-e .seat-cube:nth-child(1),\r\n  .room-d .seat-cube:nth-child(2),\r\n  .room-e .seat-cube:nth-child(2),\r\n  .room-d .seat-cube:nth-child(4),\r\n  .room-e .seat-cube:nth-child(4) {\r\n    transform: none !important;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
